<template>
  <div class="login">
    <div class="login-container container">
      <div class="row justify-content-center">
        <b-card class="login-form-card col-11 col-md-6">
          <img class="d-block mx-auto" src="../../assets/img/logo.png" alt="CARICOM IMPACS logo" width="100" />
          <h2 class="card-title mt-3 text-center">APIS Search</h2>
          <h6 class="card-subtitle mb-4 text-center">by CARICOM IMPACS</h6>

          <b-alert id="login-error" class="login-error mt-3 mb-2" :variant="alertVariant" :show="errors.length > 0 || messages.length > 0">
            {{ errors[0] || messages[0] }}
          </b-alert>

          <b-form @submit.prevent="onSubmit">
            <b-form-group label="Username" label-for="input-username">
              <b-form-input id="input-username" v-model="form.username" type="text" required></b-form-input>
            </b-form-group>

            <b-form-group label="Password" label-for="input-password">
              <b-form-input id="input-password" type="password" v-model="form.password"></b-form-input>
            </b-form-group>

            <b-button type="submit" class="my-4 py-2" block variant="primary" :disabled="isLoggingIn">
              <span class="login-btn-text" v-if="!isLoggingIn">Login</span>
              <b-spinner small v-else></b-spinner>
            </b-button>
          </b-form>
        </b-card>
      </div>
    </div>

    <footer class="footer text-center">
      <span class="copyright">
        &#169; {{ new Date().getFullYear() /* Current year */ }} Copyright:
        <a href="https://caricomimpacs.org/" target="_blank" class="text-white">CARICOM IMPACS | All rights reserved.</a>
      </span>
    </footer>
  </div>
</template>

<script>
export default {
  props: ['passedErrors'],

  data() {
    return {
      isLoggingIn: false,
      form: {
        username: '',
        password: ''
      },
      errors: [],
      messages: []
    };
  },

  mounted() {
    this.errors = this.passedErrors || [];
  },

  computed: {
    alertVariant() {
      return this.errors.length > 0 ? 'danger' : 'success';
    }
  },

  methods: {
    onSubmit() {
      this.errors = [];
      this.messages = [];
      this.isLoggingIn = true;

      this.$store
        .dispatch('login', this.form)
        .then(() => {
          this.messages.push('Logged in successfully.');
          this.isLoggingIn = false;
          setTimeout(() => {
            this.$router.push(this.$route.query.redirect || { name: 'Aviation' }).catch(() => {});
          }, 750);
        })
        .catch((err) => {
          if (!err.response) {
            this.errors.push('Error: A network error occurred.');
          } else {
            if (Array.isArray(err.response.data.message)) {
              this.errors = err.response.data.message;
            } else {
              this.errors.push(err.response.data.message || 'Something went wrong while trying to login.');
            }
          }
          this.isLoggingIn = false;
        });
    }
  }
};
</script>

<style lang="scss">
h2.card-title,
h6.card-subtitle {
  font-weight: 600;
}

.login-container {
  position: absolute;
  margin: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.card.login-form-card {
  max-width: 500px;
  border-radius: 3px !important;
  box-shadow: 0px 2px 4px 0px rgba(32, 32, 32, 0.5);
}

.login-btn-text {
  font-size: 1.2rem;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: white;
  background: var(--color-dark);
}

.copyright {
  font-size: 14px;
}
</style>
